import { render, staticRenderFns } from "./IntroCreate.vue?vue&type=template&id=05001275&"
import script from "./IntroCreate.vue?vue&type=script&lang=js&"
export * from "./IntroCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports